import { APIClient } from "@/utils/httpClient";
import { APIError } from "@/errors";
import { Action } from "@/types/action";

export const getAction = async (campaignID: string, actionID: string) => {
    const response = await APIClient.get(`/campaigns/${campaignID}/actions/${actionID}`);
    if (response.success) {
        return response.data as Action;
    } else {
        throw new APIError(response.message);
    }
};